"use client";

import { trpcApi } from "@lattice/frontend/lib/trpc/client/index";
import TradeSummaryChart from "../charts/trade-summary-chart";
import StockPoliticianTradesTable from "./stock-politician-trades-table";

export default function StockPoliticianTradesChart({
  symbol,
  view,
}: {
  symbol: string;
  view: "table" | "chart";
}) {
  const [data] = trpcApi.stock.get_congressman_trading.useSuspenseQuery(
    {
      symbol,
    },
    { refetchOnMount: false },
  );

  if (!data.length)
    return (
      <div className="h-[600px] flex items-center justify-center text-muted-foreground">
        No data available
      </div>
    );

  return (
    <div>
      {view === "table" ? (
        <StockPoliticianTradesTable data={data} />
      ) : (
        <TradeSummaryChart
          data={data.map((d) => ({
            id: d.id,
            transactionDate: d.TransactionDate,
            amount: d.Amount,
            isBuy: d.Transaction?.includes("Purchase") ?? false,
            isSell: d.Transaction?.includes("Sale") ?? false,
          }))}
        />
      )}
    </div>
  );
}
